export default "__VITE_ASSET__lY9kowqT__"